import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  ReferenceManyField,
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SingleFieldList,
  TextField,
  EditButton,
  required,
  BooleanField,
  BooleanInput,
} from "react-admin";

export const CategoryList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField displayName="CategoryId" source="categoryId" />
      <TextField source="path" />
      <TextField source="label" />
      <BooleanField source="enabled" valueLabelTrue="Enabled" valueLabelFalse=""  FalseIcon={null} />
      <ArrayField source="children">
        <SingleFieldList>
          <ChipField source="id" />
        </SingleFieldList>
      </ArrayField>
    </Datagrid>
  </List>
);


export const CategoryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextField displayName="CategoryId" source="categoryId" />
      <TextInput  label="Label" source="label" />
      <BooleanInput label="Enabled" source="enabled" />

    </SimpleForm>
  </Edit>
);
